import { getWindowLocation } from 'utils/window';

import { isValidAbsoluteRedirectUrl } from '../helpers/isValidAbsoluteRedirectUrl';

export const useAltaLoginUrlParams = () => {
  /**
   * urlParams
   * email: if exists, we go straight to searching for the possible logins for the email skipping the email
   * form unless no valid namespaces are found. The user can hit the "Not you" button to reset the email.
   * orgId: if exists, we use it to filter the allowed namespaces to only ones where the user can login
   * to the org with the orgId.
   * service: if exists, we use it to know if we are logging into dmp or aware. if dmp, we only show
   * namespaces that can login to dmp orgs
   * region: if exists, we only show namespaces within this region
   * forgotPassword: if true show forgotPassword flow
   * resetPassword: if true show resetPassword flow
   */
  const urlParams = new URLSearchParams(getWindowLocation().search);
  const orgId = urlParams.get('orgId');
  const emailParam = urlParams.get('email');
  const service = urlParams.get('service');
  const region = urlParams.get('region') ?? '';
  const token = urlParams.get('token');
  const resetPassword = urlParams.get('resetPassword');
  const nonce = urlParams.get('nonce') ?? '';

  let redirectUrl = urlParams.get('redirectUrl') ?? '';

  /**
   * This currently happens when the user is redirected from Aware. We were asked to
   * assist in removing the /login from the redirectUrl.
   */
  if (isValidAbsoluteRedirectUrl(redirectUrl)) {
    redirectUrl = redirectUrl.replace('/login', '');
  }

  return {
    orgId,
    emailParam,
    service,
    region: region as OP.Env,
    token,
    resetPassword,
    redirectUrl,
    nonce,
  };
};
